export default "__VITE_ASSET__1KTqgUuG__"